import { HttpErrorResponse } from "@angular/common/http";
import { Observable } from "rxjs";

export function parseErrorBlob(error: HttpErrorResponse): Observable<any> {
  const reader: FileReader = new FileReader();

  const observable = new Observable((observer: any) => {
    reader.onloadend = (e) => {
      observer.error({
        ...error,
        error: JSON.parse(reader.result.toString())
      });
      observer.complete();
    };
  });
  reader.readAsText(error.error);
  return observable;
}
